import { SWReactIcons } from "@similarweb/icons";
import {
    DropdownGroupItem,
    GroupContentWrapper,
    GroupItemSubText,
    GroupItemText,
    GroupTextWrapper,
} from "../../styles";
import type { ICustomSegmentsGroup } from "app/services/segments/segmentsApiService";
import DisabledTooltip from "../DisabledTooltip";

type GroupItemProps = {
    isSelectedInInput?: boolean;
    group: ICustomSegmentsGroup;
    hasWebsites: boolean;
    activeId?: string;
};

const GroupItem = ({ group, isSelectedInInput, activeId, hasWebsites, ...restProps }: GroupItemProps) => (
    <DropdownGroupItem
        id={group.id}
        isSelectedInInput={isSelectedInInput}
        isActive={activeId === group.id}
        isDisabled={group.isDisabled}
        {...restProps}
    >
        <SWReactIcons
            iconName="segment-folder"
            size="sm"
        />
        <GroupContentWrapper>
            <GroupTextWrapper>
                <GroupItemText isDisabled={!isSelectedInInput ? group.isDisabled : null}>{group.name}</GroupItemText>
                <GroupItemSubText isDisabled={!isSelectedInInput ? group.isDisabled : null}>{`${
                    hasWebsites ? group.segments.length + group.websites.length : group.segments.length
                }  segments comparison`}</GroupItemSubText>
            </GroupTextWrapper>
            {!isSelectedInInput && group.isDisabled ? <DisabledTooltip isGroup /> : null}
        </GroupContentWrapper>
    </DropdownGroupItem>
);

export default GroupItem;
